module.exports = __webpack_public_path__ + "img/7-white.e02080a6.svg";